// The transcript's own icons, drawn like the board's (components/Icons.tsx):
// 16 px boxes, strokes in the text's colour. Moved from today's Code tab
// (code/icons.tsx there), with the alert and the chevron down of today's
// components/Icons.tsx, which only the transcript uses here.
import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement> & { size?: number }

function Svg({ size = 16, children, ...rest }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" {...rest}>
      {children}
    </svg>
  )
}

/** Copy a reply or a prompt: two sheets, one over the other. */
export function CopyIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="5.75" y="5.75" width="7.5" height="7.5" rx="1.6" stroke="currentColor" strokeWidth="1.3" />
      <path d="M10.25 3.6V3.4a1.15 1.15 0 0 0-1.15-1.15H3.9A1.15 1.15 0 0 0 2.75 3.4v5.2A1.15 1.15 0 0 0 3.9 9.75h.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </Svg>
  )
}

/** A step of a plan that runs now: a ring not yet closed. */
export function StepNowIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.8" strokeDasharray="24 11" strokeLinecap="round" />
    </Svg>
  )
}

/** A step of a plan still to come: an empty circle. */
export function StepTodoIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="8" cy="8" r="5.25" stroke="currentColor" strokeWidth="1.4" />
    </Svg>
  )
}

/** A call that was refused. */
export function DeniedIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="m4.2 11.8 7.6-7.6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </Svg>
  )
}

/** A call its turn's stop cut short: a square in a ring. */
export function StoppedIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="8" cy="8" r="5.5" stroke="currentColor" strokeWidth="1.4" />
      <rect x="6" y="6" width="4" height="4" rx="0.6" fill="currentColor" />
    </Svg>
  )
}

/** Something went wrong: a triangle with a mark. */
export function AlertIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M8 2 14.5 13.5h-13z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M8 6.5v3.2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11.6" r=".85" fill="currentColor" />
    </Svg>
  )
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="m4.5 6.5 3.5 3.5 3.5-3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  )
}
